export default __webpack_public_path__ + "static/media/side-banner.66b3a2d5.svg";